import { useContext} from 'react';
import SidebarContext, { type SidebarContextType } from '../context/SidebarProvider';

const useSidebar = (): SidebarContextType => {    
    return useContext(SidebarContext);
}

export default useSidebar;